<svg #svg class="stage-svg" [attr.viewBox]="'0 0 ' + VIEW_W + ' ' + VIEW_H"
     preserveAspectRatio="xMidYMid meet"
     (pointermove)="onPointerMove($event)"
     (pointerup)="onPointerUp($event)"
     (pointercancel)="onPointerUp($event)"
     (pointerleave)="onPointerUp($event)">

  <defs>
    <radialGradient id="sym-panel" cx="50%" cy="38%" r="80%">
      <stop offset="0%" stop-color="#3a2a6b" />
      <stop offset="55%" stop-color="#241a4d" />
      <stop offset="100%" stop-color="#160f33" />
    </radialGradient>

    <linearGradient id="sym-crystal" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" stop-color="#7ef0ff" />
      <stop offset="50%" stop-color="#a97bff" />
      <stop offset="100%" stop-color="#ff8fd0" />
    </linearGradient>

    <linearGradient id="sym-crystal-win" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" stop-color="#fff4b0" />
      <stop offset="50%" stop-color="#ffd34d" />
      <stop offset="100%" stop-color="#ff9e57" />
    </linearGradient>

    <filter id="sym-glow" x="-40%" y="-40%" width="180%" height="180%">
      <feGaussianBlur stdDeviation="7" result="b" />
      <feMerge>
        <feMergeNode in="b" />
        <feMergeNode in="SourceGraphic" />
      </feMerge>
    </filter>

    <clipPath id="sym-clip">
      <rect x="0" y="0" [attr.width]="VIEW_W" [attr.height]="VIEW_H" rx="0" />
    </clipPath>
  </defs>

  <!-- Panel backdrop -->
  <rect x="0" y="0" [attr.width]="VIEW_W" [attr.height]="VIEW_H" rx="0"
        fill="url(#sym-panel)" stroke="rgba(255,255,255,0.14)" stroke-width="2" />

  <g clip-path="url(#sym-clip)">
    <!-- Starfield -->
    <g class="starfield" fill="#ffffff">
      <circle cx="120" cy="90" r="2" opacity="0.5" />
      <circle cx="300" cy="60" r="1.6" opacity="0.35" />
      <circle cx="520" cy="110" r="2.4" opacity="0.6" />
      <circle cx="760" cy="70" r="1.4" opacity="0.4" />
      <circle cx="900" cy="150" r="2" opacity="0.5" />
      <circle cx="180" cy="520" r="1.8" opacity="0.45" />
      <circle cx="430" cy="560" r="1.4" opacity="0.35" />
      <circle cx="680" cy="540" r="2.2" opacity="0.55" />
      <circle cx="860" cy="470" r="1.6" opacity="0.4" />
      <circle cx="60" cy="300" r="1.6" opacity="0.4" />
      <circle cx="960" cy="330" r="1.8" opacity="0.45" />
    </g>

    <!-- Hint ghosts: every true axis -->
    <g *ngIf="hintVisible" class="hint-axes">
      <line *ngFor="let h of hintLines"
            [attr.x1]="h.a.x" [attr.y1]="h.a.y" [attr.x2]="h.b.x" [attr.y2]="h.b.y"
            stroke="#7ef0ff" stroke-width="3" stroke-dasharray="10 12" opacity="0.5" />
    </g>

    <!-- Live mirror preview -->
    <polygon *ngIf="!solvedState" class="reflection" [attr.points]="reflectionPoints"
             fill="rgba(126,240,255,0.10)" stroke="rgba(126,240,255,0.55)"
             stroke-width="2.5" stroke-dasharray="7 9" />

    <!-- The crystal shape -->
    <polygon class="crystal" [class.win]="solvedState"
             [attr.points]="shapePoints"
             [attr.fill]="solvedState ? 'url(#sym-crystal-win)' : 'url(#sym-crystal)'"
             [attr.stroke]="solvedState ? '#fff2c2' : '#ffffff'" stroke-width="4"
             stroke-linejoin="round" filter="url(#sym-glow)" />

    <!-- Mirror beam -->
    <g class="beam" [class.win]="solvedState">
      <line class="beam-glow"
            [attr.x1]="beamEnds.a.x" [attr.y1]="beamEnds.a.y"
            [attr.x2]="beamEnds.b.x" [attr.y2]="beamEnds.b.y" />
      <line class="beam-core"
            [attr.x1]="beamEnds.a.x" [attr.y1]="beamEnds.a.y"
            [attr.x2]="beamEnds.b.x" [attr.y2]="beamEnds.b.y" />
    </g>

    <!-- Success sparkles -->
    <g class="sparkles" *ngIf="solvedState">
      <circle *ngFor="let s of sparkles" class="sparkle"
              [attr.cx]="s.x" [attr.cy]="s.y" [attr.r]="s.r"
              [style.animation-delay.ms]="s.delay" fill="#fff4b0" />
    </g>
  </g>

  <!-- Beam body grab target (thick invisible hit line) -->
  <line class="beam-hit"
        [attr.x1]="beamEnds.a.x" [attr.y1]="beamEnds.a.y"
        [attr.x2]="beamEnds.b.x" [attr.y2]="beamEnds.b.y"
        stroke="transparent" stroke-width="46"
        (pointerdown)="onBodyDown($event)" />

  <!-- Draggable handles (big hit area for touch TVs) -->
  <g class="handle" [class.locked]="solvedState" (pointerdown)="onHandleDown('A', $event)">
    <circle [attr.cx]="handleA.x" [attr.cy]="handleA.y" r="42" fill="transparent" />
    <circle class="handle-halo" [attr.cx]="handleA.x" [attr.cy]="handleA.y" r="26" />
    <circle class="handle-core" [attr.cx]="handleA.x" [attr.cy]="handleA.y" r="15" />
  </g>
  <g class="handle" [class.locked]="solvedState" (pointerdown)="onHandleDown('B', $event)">
    <circle [attr.cx]="handleB.x" [attr.cy]="handleB.y" r="42" fill="transparent" />
    <circle class="handle-halo" [attr.cx]="handleB.x" [attr.cy]="handleB.y" r="26" />
    <circle class="handle-core" [attr.cx]="handleB.x" [attr.cy]="handleB.y" r="15" />
  </g>
</svg>
